/** Pinia 持久化 key，与小程序入口参数语义一致 */
export const STORAGE_ENTRY_PARAMS_KEY = 'cap_h5_entry_params'
